<template>
  <v-icon v-bind="$attrs" class="em-icon" :color="color" />
</template>

<script setup>
defineProps({
  color: { type: String, default: 'neutral-lighten-1' }
})
</script>
